<template>
	<el-dialog class="addDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
				收款账户
			</div>
		</div>
		<div class="dislogConent">
			<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
				<el-form-item label="真实姓名：" prop="sk_name">
					<el-input v-model="ruleForm.sk_name" placeholder="请输入真实姓名" />
				</el-form-item>
				<el-form-item label="银行卡号：" prop="sk_num">
					<el-input v-model="ruleForm.sk_num" placeholder="请输入银行卡号" />
				</el-form-item>
				<el-form-item label="开户行：" prop="sk_bank">
					<el-input v-model="ruleForm.sk_bank" placeholder="请输入开户行" />
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer">
			<div class="menuBox">
				<el-button class="submit" type="primary" size="medium" @click="submitForm('ruleForm')">提交</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import citys from "@/assets/js/citys.js";
	export default {
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Object,
				default: () => {},
			}
		},
		watch: {
			data: {
				handler(newValue) {
					this.ruleForm = {
						...newValue
					}
				},
				deep: true
			}
		},
		data() {
			return {
				ruleForm: {
					sk_name: '',
					sk_bank: '',
					sk_num: ''
				},
				rules: {
					sk_name: [{
						required: true,
						message: '请输入真实姓名',
						trigger: 'blur'
					}],
					sk_bank: [{
						required: true,
						message: '请输入银行卡号',
						trigger: 'blur'
					}],
					sk_num: [{
						required: true,
						message: '请输入开户行',
						trigger: 'blur'
					}],
				},
				citys: citys,
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/Hua/xinxi_save', {
							...this.ruleForm,
						}).then(res => {
							if (res.code == 1) {
								this.$emit('update')
								this.handleClose()
							} else {
								this.$message.success(res.msg)
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.addDialog {

		::v-deep .el-dialog {
			width: 7.40rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									padding: 0 .16rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>
<style>
	.el-cascader-node {
		margin-bottom: 0 !important;
	}
</style>